export default function TabBar({ tabBar, setTabBar, stats = {} }) {
    const data = [
        { label: `All: ${stats.all ?? 0}`, full: `All transaction: ${stats.all ?? 0}`, value: 0 },
        { label: `Testament: ${stats.testament ?? 0}`, full: `Testament: ${stats.testament ?? 0}`, value: 1 },
        { label: `To Claim: ${stats.to_claim ?? 0}`, full: `To Claim: ${stats.to_claim ?? 0}`, value: 2 },
        { label: `Claimed: ${stats.claimed ?? 0}`, full: `Claimed: ${stats.claimed ?? 0}`, value: 3 },
    ];

    return (
        <div className="w-full mt-4">
            <div className="flex flex-wrap gap-2 p-2 bg-[#141414] border border-[#2C2C2C] rounded-[10px]">
                {data.map(({ label, full, value }) => (
                    <button
                        key={value}
                        type="button"
                        onClick={() => setTabBar(value)}
                        className={`whitespace-nowrap rounded-[6px] px-3 py-2 text-[13px] sm:text-[15px] flex-1 min-w-[calc(50%-4px)] sm:min-w-0 sm:flex-none ${
                            tabBar === value
                                ? 'bg-[#FCBF07] text-[#32330E] font-Inter-Bold'
                                : 'text-[#86888C] font-Inter-Regular'
                        }`}
                    >
                        <span className="sm:hidden">{label}</span>
                        <span className="hidden sm:inline">{full}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
